import RequestSummarySectionResourceModel from '../../generated/types/model/resource/RequestSummarySectionResourceModel';

export default class RequestSummarySectionResourceViewModel extends RequestSummarySectionResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
